import { Box, Typography } from '@mui/material';
import { GameStatus } from '../../../constants/gameConstants';

const ScoreDisplayTicker = ({ game }) => {
  const sets = Array.isArray(game?.sets) ? game.sets : [];
  const currentSetIndex = sets.findIndex((set) => String(set?.id) === String(game?.currentSet));
  const currentSet = currentSetIndex >= 0 ? sets[currentSetIndex] : sets[sets.length - 1] || null;
  const currentSetCount = sets.length > 0 ? sets.length : 1;

  const getTeamLabel = (team) => {
    if (!team) {
      return '-';
    }

    if (team.name) {
      return team.name;
    }

    if (Array.isArray(team.players) && team.players.length > 0) {
      return team.players.join(', ');
    }

    return '-';
  };

  const getTeamColor = (team) => {
    const color = team?.color;

    if (!color) {
      return 'text.primary';
    }

    const isHexColor = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(color);
    return isHexColor ? color : `${color}.main`;
  };

  const getCurrentSetScore = (teamId) => {
    if (!currentSet || !Array.isArray(currentSet.scores)) {
      return 0;
    }

    return currentSet.scores.reduce((total, end) => {
      return total + (end?.teamScores?.[teamId] || 0);
    }, 0);
  };

  const getPlayedEnds = () => {
    if (!currentSet || !Array.isArray(currentSet.scores)) {
      return 0;
    }

    return currentSet.scores.filter((end) => Object.keys(end?.teamScores || {}).length > 0).length;
  };

  const getDisplayScore = (team) => {
    if (!team?.id) {
      return 0;
    }

    if (game.status === GameStatus.PLAYOFF) {
      return game.playoff?.teamScores?.[team.id] || 0;
    }

    if (game.status === GameStatus.COMPLETE) {
      return game.teamTotals?.[team.id] || 0;
    }

    return getCurrentSetScore(team.id);
  };

  const getStatusLabel = () => {
    if (game.status === GameStatus.PLAYOFF) {
      return `Playoff ${game.playoff?.currentSet ? `P${game.playoff.currentSet - 1}` : ''}`.trim();
    }

    return `End ${getPlayedEnds()}`;
  };

  const teamA = game?.teams?.teamA;
  const teamB = game?.teams?.teamB;

  return game && teamA && teamB ? (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent={'center'}
      alignItems={'center'}
      gap={1.5}
      sx={{
        whiteSpace: 'nowrap',
        minWidth: 0,
        width: '100%'
      }}>
      <Typography
        variant="body2"
        fontWeight={700}
        sx={{
          color: getTeamColor(teamA),
          textAlign: 'center'
        }}>
        {getTeamLabel(teamA)}
      </Typography>

      <Typography variant="body2" fontWeight={800} color="text.primary" textAlign="center">
        {getDisplayScore(teamA)}
      </Typography>

      <Typography variant="caption" fontWeight={700} color="text.secondary" textAlign="center">
        |
      </Typography>

      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography variant="caption" fontWeight={700} color="text.secondary" textAlign="center">
          {getStatusLabel()}
        </Typography>
        <Typography variant="caption" color="text.secondary" textAlign="center" lineHeight={1}>
          Set {currentSetCount}
        </Typography>
      </Box>

      <Typography variant="caption" fontWeight={700} color="text.secondary" textAlign="center">
        |
      </Typography>

      <Typography variant="body2" fontWeight={800} color="text.primary" textAlign="center">
        {getDisplayScore(teamB)}
      </Typography>

      <Typography
        variant="body2"
        fontWeight={700}
        sx={{
          color: getTeamColor(teamB),
          textAlign: 'center'
        }}>
        {getTeamLabel(teamB)}
      </Typography>
    </Box>
  ) : null;
};

export default ScoreDisplayTicker;
